import * as React from 'react';
import { Col, Row } from 'antd';
import { observer } from 'mobx-react';
import * as moment from 'moment';

import { DateView } from 'src/core/ui/date.view';
import { RegionEditorController } from 'src/app/general/regions/parts/region-editor.controller';
import { ProductCategoryEditorController } from 'src/app/products/product-categories/parts/product-category-editor.controller';
import { ProductEditorController } from 'src/app/products/products/parts/product-editor.controller';
import { ProductServiceTypeEditorController } from 'src/app/products/product-service-types/parts/product-service-type-editor.controller';
import { SearchTaxonomies } from 'src/app/bookings/search/requests/search-taxonomy';

interface Props {
	currentSearch: SearchTour;
	fieldsTaxonomy: TaxonomicField[];
	onChangeCategory: (productCategoryId: number) => Promise<void>;
	setBusy(isBusy: boolean);
}

@observer
export class SearchTourView extends React.Component<Props, {}> {

	public render(): React.ReactNode {
		if (this.props.currentSearch == null) {
			return null;
		}

		const { currentSearch, fieldsTaxonomy, onChangeCategory, setBusy } = this.props;
		return (
			<Row gutter={16}>
				<Col xs={24} lg={16}>
					<Row gutter={16}>
						<Col xs={24}>
							<RegionEditorController
								mode="edit"
								onChanged={(value) => {
									currentSearch.regionId = value != null ? value.id : null;
									currentSearch.regionName = value != null ? value.displayName : null;
								}}
								value={currentSearch.regionId}
								setBusy={setBusy}
							/>
						</Col>
						<Col xs={24} lg={12}>
							<ProductCategoryEditorController
								mode="edit"
								onChanged={(value) => {
									if (value != null) {
										currentSearch.productCategoryId = value.id;
										currentSearch.productCategoryDisplayName = value.displayName;
										onChangeCategory(value.id);
									} else {
										currentSearch.productCategoryId = null;
										currentSearch.productCategoryDisplayName = null;
										currentSearch.productServiceTypeId = null;
										currentSearch.productServiceTypeDisplayName = null;
										onChangeCategory(null);
									}
								}}
								value={currentSearch.productCategoryId}
								productType={9}
								setBusy={setBusy}
							/>
						</Col>
						<Col xs={24} lg={12}>
							<ProductServiceTypeEditorController
								categoryId={currentSearch.productCategoryId}
								mode={currentSearch.productCategoryId ? 'edit' : 'display'}
								onChanged={(value) => {
									currentSearch.productServiceTypeId = value != null ? value.id : null;
									currentSearch.productServiceTypeDisplayName = value != null ? value.displayName : null;
								}}
								value={currentSearch.productServiceTypeId}
								setBusy={setBusy}
							/>
						</Col>
						<Col xs={24}>
							<ProductEditorController
								mode="edit"
								label="Tour"
								onChanged={(value) => {
									currentSearch.productId = value != null ? value.id : null;
									currentSearch.productName = value != null ? value.displayName : null;
								}}
								value={currentSearch.productId}
								productType={9}
								regionId={currentSearch.regionId}
								categoryId={currentSearch.productCategoryId}
								serviceId={currentSearch.productServiceTypeId}
								setBusy={setBusy}
								afterLoad={this.afterProductLoaded}
							/>
						</Col>
						<Col xs={24}>
							<hr />
							<SearchTaxonomies
								model={currentSearch}
								fieldsTaxonomy={fieldsTaxonomy}
								setBusy={setBusy}
							/>
						</Col>
					</Row>
				</Col>
				<Col xs={24} lg={8}>
					<Row gutter={16}>
						<Col xs={24} lg={10}>
							<DateView
								required={true}
								mode="edit"
								label="Start Date"
								value={currentSearch.startDate}
								onChanged={newVal => {
									currentSearch.startDate = newVal;
									currentSearch.endDate = newVal;
								}}
								format="small-date"
								dateUsage="utc"
							/>
						</Col>
					</Row>
				</Col>
			</Row>
		);
	}

	private afterProductLoaded = (selected: ProductSummary, options: ProductSummary[]) => {
		if (selected && options.every(e => e.id !== selected.id)) {
			this.props.currentSearch.productId = null;
			this.props.currentSearch.productName = null;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/search/requests/search-tour.view.tsx